export function isBetaWebsite() {
  return document.domain.startsWith('beta');
}
